import { useEffect, useRef, useState } from "react"
import axiosInstance from "../services/axiosInstance"
import APIUrls from "../services/APIUrls"
import jQuery from "jquery"

interface BookmarkHandlerProps {
  projectId: string
  parentHttpDomain: string
  targetPreviewId?: string
  isFinalPreviewChecked?: boolean
}

export default function BookmarkHandler({
  projectId,
  parentHttpDomain,
  targetPreviewId = "target-preview",
  isFinalPreviewChecked
}: BookmarkHandlerProps) {


  const [isBookmarkHandled, setIsBookmarkHandled] = useState(true);

  useEffect(() => {
    function handleBookmarkActions(e: MessageEvent) {
      if (!e.data) return

      let message
      try {
        message =
          e.type === "webpackInvalid" ||
            (typeof e.data === "object" && e.data.type === "webpackWarnings") ||
            (typeof e.data === "object" && e.data.type === "webpackClose")
            ? e.data
            : JSON.parse(e.data)
      } catch (err) {
        // Silent out webpack related exceptions
        return
      }

      // Handle bookmark creation
      if (message.action === "bookmark") {
        axiosInstance
          .post(APIUrls.BOOKMARK_ON_TRANSLATION(projectId, message.docSegPos))
          .then((res) => {
            const bookmarkTU = res?.data
            const docSegPos = bookmarkTU?.docSegPos

            if (docSegPos) {

              const message = {
                                data: docSegPos,
                                action: "SHOW_BOOMARK",
                              };

              const targetIframe = document.getElementById(targetPreviewId) as HTMLIFrameElement | null;
              if (targetIframe && targetIframe.contentWindow) {
                targetIframe.contentWindow.postMessage(JSON.stringify(message), '*');
              }

              // Update UI to show bookmark
              jQuery(".bookmark").each((i, obj) => {
                jQuery(obj).removeClass("bookmark")
              })

              //used by line by line bookmark
              const element = document.getElementById(bookmarkTU.id);
              if (element) {
                element.classList.add("bookmark");
              }

              // jQuery(`span#${bookmarkTU.idForUrl}`).addClass("bookmark")
              // jQuery(`span#${bookmarkTU.idForUrl}`).addClass("focus")
            }
          })
          .catch((err) => {
            console.error("Error creating bookmark:", err)
          })
      }

      // Handle bookmark removal
      if (message.action === "REMOVE_BOOKMARK") {
        axiosInstance
          .post(APIUrls.REMOVE_BOOKMARK(projectId))
          .then(() => {
            // Remove bookmark styling from all elements
            jQuery(".bookmark").each((i, obj) => {
              jQuery(obj).removeClass("bookmark")
            })
          })
          .catch((err) => {
            console.error("Error removing bookmark:", err)
          })

          const message = {action: "REMOVE_BOOKMARK"};
          const targetIframe = document.getElementById(targetPreviewId) as HTMLIFrameElement | null;
          if (targetIframe && targetIframe.contentWindow) {
            targetIframe.contentWindow.postMessage(JSON.stringify(message), '*');
          }

      }

      // Handle bookmark retrieval
      if (message.action === "getBookmark") {
        handleBookmark()
      }
    }

    // Add event listener for message events
    window.addEventListener("message", handleBookmarkActions)

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("message", handleBookmarkActions)
    }
  }, [])


  function handleBookmark() {
    axiosInstance
      .get(APIUrls.GET_BOOKMARK_ON_TRANSLATION(projectId))
      .then((res) => {
        const docSegPos = res?.data?.docSegPos

        if (docSegPos) {
            const message = {
                data: docSegPos,
                action: "SHOW_BOOMARK",
              };
          const targetIframe = document.getElementById(targetPreviewId) as HTMLIFrameElement | null;
          if (targetIframe && targetIframe.contentWindow) {
            targetIframe.contentWindow.postMessage(JSON.stringify(message), '*');
          }

        }
      })
      .catch((err) => {
        console.error("Error retrieving bookmark:", err)
      })
  }

  useEffect(() => {
    if (!isFinalPreviewChecked && !isBookmarkHandled) {
      handleBookmark();
      setIsBookmarkHandled(true);
    }

    if (isFinalPreviewChecked) {
      setIsBookmarkHandled(false);
    }
  }, [isFinalPreviewChecked]);


  // Return null as this component does not render anything
  return null
}

